module.exports = __webpack_public_path__ + "img/CY.e629ec42.png";